import { render, staticRenderFns } from "./Promotion_assorted.vue?vue&type=template&id=575e3607&scoped=true&"
import script from "./Promotion_assorted.vue?vue&type=script&lang=js&"
export * from "./Promotion_assorted.vue?vue&type=script&lang=js&"
import style0 from "./Promotion_assorted.vue?vue&type=style&index=0&id=575e3607&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575e3607",
  null
  
)

export default component.exports